/**
 * Interface for the 'Pets' data
 */
export interface PetsEntity {
  id: string | number // Primary ID
  name: string
}
